<template>
  <div class="main-container">
    <div class="container header column">
      <h1>{{ getMessage('TTL_SELECCIONA_ESPECIALIDAD') }}</h1>
    </div>
    <div class="container">
      <div class="appointment-list" v-for="(serviciosPartial, index) in pagedServicios"
          :key="index">
        <div
          class="service"
          @click="printNumber(servicio)"
          v-for="servicio in serviciosPartial"
          :key="servicio.id"
        >
          <div class="appointment-details">
            <div class="appointment-date">
              <div>{{ servicio.value }}</div>
            </div>
          </div>
          <div class="btn-select">
            <span class="span-ok">{{ getMessage('BTN_OKAY') }}</span>
          </div>
        </div>
      </div>
      <app-back-home :compFrom="'serviceSelector'"></app-back-home>
    </div>
    <div class="container" v-if="enableScroll">
      <button
        @click="scrollServices(false)"
        :disabled="disablePrevious"
        class="btn-primary page-button"
      >
        <i class="arrow left"></i>
      </button>
      <button @click="scrollServices(true)" :disabled="disableNext" class="btn-primary page-button">
        <i class="arrow right"></i>
      </button>
    </div>
    <div class="container">
      <router-link :to="{ name: 'TotemHome' }" tag="button" class="btn-secondary">{{ getMessage('BTN_VOLVER_EMPEZAR') }}</router-link>
    </div>
    <div class="container"></div>
    <app-loader></app-loader>
  </div>
</template>
<script>
import BackHome from '@/components/AutoRecepcion/BackHome'
import { mapActions, mapGetters } from 'vuex'
import { chunk } from 'chunk'
import Loader from '@/components/AutoRecepcion/Loader'

export default {
  components: {
    'app-loader': Loader,
    'app-back-home': BackHome
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  mounted: function () {
    var vm = this
    this.fetchServices().then(function (response) {
      vm.servicios = vm.splitServices(response)
      vm.pagedServicios = vm.servicios.slice(vm.bottom, vm.top)
      if (vm.servicios.length > vm.top) {
        vm.enableScroll = true
      }
    })
  },
  data () {
    return {
      servicios: [],
      pagedServicios: [],
      top: 2,
      bottom: 0,
      enableScroll: false,
      disableNext: false,
      disablePrevious: true
    }
  },
  methods: {
    ...mapActions('InitConfig', [
      'fetchServices'
    ]),
    splitServices (services) {
      return chunk(services, 3)
    },
    scrollServices (next) {
      var vm = this
      if (next) {
        if (vm.top < vm.servicios.length) {
          vm.disablePrevious = false
          vm.bottom += 2
          vm.top += 2
          vm.pagedServicios = vm.servicios.slice(vm.bottom, vm.top)
          if (vm.top >= vm.servicios.length) vm.disableNext = true
        }
      } else {
        if (vm.bottom > 0) {
          vm.disableNext = false
          vm.bottom -= 2
          vm.top -= 2
          vm.pagedServicios = vm.servicios.slice(vm.bottom, vm.top)
          if (vm.bottom === 0) vm.disablePrevious = true
        }
      }
    },
    printNumber (service) {
      this.$router.push({
        name: 'printNumber',
        params: {
          serviceId: service.id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './styles.scss';
.page-button {
  width: 250px;
}
.arrow {
  border: solid white;
  border-width: 0 10px 10px 0;
  display: inline-block;
  padding: 10px;
}
.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  margin-top: 10px;
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 10px;
}
button:disabled {
  background: #dddddd;
  border: 1px solid #dddddd;
}
.appointment{
    margin: 15px;
}
.appointment-list{
  min-height: 300px;
}
</style>
